import { Box, Grid } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { useTranslate } from "src/locales/use-locales";
import { initialFormData, FormDataType } from "./formMockState";
import { useState } from "react";

const PostSurgeryTab = ({ isEditable }: { isEditable: boolean }) => {
    const { t } = useTranslate();
    const [formData] = useState<FormDataType>(initialFormData);

    const handleInputChange = (field: keyof FormDataType, value: any) => {

    };

    const handleRadioChange = (field: keyof FormDataType, value: string) => {

    };

    const handleCheckboxChange = (
        group: keyof FormDataType,
        key: string,
        value: boolean
    ) => {

    };

    return (
        <Box>

            <Box>
                {/* Teslim Eden Bilgisi */}
                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
                    <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
                        <strong>{t("surgery-pre-post-preparation.deliverer-info")}</strong>
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            {/* Tarih */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.date")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    type="date"
                                    fullWidth
                                    size="medium"
                                    value={formData.teslimTarihiPost || ""}
                                    onChange={(e) => handleInputChange("teslimTarihiPost", e.target.value)}
                                />
                            </Grid>

                            {/* Teslim Eden */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.deliverer")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    fullWidth
                                    size="medium"
                                    value={formData.teslimEdenPost}
                                    onChange={(e) => handleInputChange("teslimEdenPost", e.target.value)}
                                />
                            </Grid>

                            {/* Teslim Alan */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.receiver")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    fullWidth
                                    size="medium"
                                    value={formData.teslimAlanPost}
                                    onChange={(e) => handleInputChange("teslimAlanPost", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                {/* Ameliyat Bilgileri */}
                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
                    <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
                        <strong>{t("surgery-pre-post-preparation.surgery-info")}</strong>
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            {/* Operasyon Doktor Adı */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.surgeon")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    fullWidth
                                    size="medium"
                                    value={formData.operasyonDoktorAdi}
                                    onChange={(e) => handleInputChange("operasyonDoktorAdi", e.target.value)}
                                />
                            </Grid>

                            {/* Ameliyat Hemşiresi */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.surgery-nurse")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    fullWidth
                                    size="medium"
                                    value={formData.ameliyatHemsiresi}
                                    onChange={(e) => handleInputChange("ameliyatHemsiresi", e.target.value)}
                                />
                            </Grid>

                            {/* Ameliyat Adı */}
                            <Grid item xs={12} md={4}>
                                <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.surgery-name")}</ByzMuiTypography>
                                <ByzMuiTextField
                                    fullWidth
                                    size="medium"
                                    value={formData.ameliyatAdi}
                                    onChange={(e) => handleInputChange("ameliyatAdi", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                {/* Hasta Bilgileri Bölümü */}
                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>
                    <Box sx={{ background: "#EBF5FF", px: 2, py: 1, borderBottom: "1px solid #e0e0e0" }}>
                        <strong>{t("surgery-pre-post-preparation.patient-info")}</strong>
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <Grid container spacing={2}>
                            {/* İlk Kolon (1-6) */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2 }}>

                                    <Box sx={{ p: 2 }}>
                                        {/* 1) Bölge İşaretlenmesi */}
                                        <Box sx={{ mb: 2 }}>
                                            <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q1")}</ByzMuiTypography>

                                            {/* Tarih Alanı */}
                                            <ByzMuiTextField
                                                type="date"
                                                fullWidth
                                                size="medium"
                                                value={formData.bolgeIsaretlemesiTarih || ""}
                                                onChange={(e) => handleInputChange("bolgeIsaretlemesiTarih", e.target.value)}
                                                sx={{ mb: 2 }}
                                            />

                                            {/* Radyo Buton */}
                                            <Grid container spacing={2} alignItems="center">

                                                <Grid item xs={12} md={8}>
                                                    <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                        <ByzMuiRadioButton
                                                            typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                            layout="row"
                                                            value={formData.bolgeIsaretlemesiYapildiMiRadio}
                                                            onChange={(e) => handleRadioChange("bolgeIsaretlemesiYapildiMiRadio", e.target.value)}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                            {/* Checkboxlar - Her zaman görünür */}
                                            <Box sx={{ pl: "22px", mt: 1 }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                    <ByzMuiCheckBox
                                                        text={t("surgery-pre-post-preparation.form.bilateral")}
                                                        checked={formData.bolgeIsaretlemesiCheckbox.bilateral}
                                                        onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "bilateral", e.target.checked)}
                                                    />
                                                    <ByzMuiCheckBox
                                                        text={t("surgery-pre-post-preparation.form.right")}
                                                        checked={formData.bolgeIsaretlemesiCheckbox.sag}
                                                        onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "sag", e.target.checked)}
                                                    />
                                                    <ByzMuiCheckBox
                                                        text={t("surgery-pre-post-preparation.form.single-organ")}
                                                        checked={formData.bolgeIsaretlemesiCheckbox.tekliOrgan}
                                                        onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "tekliOrgan", e.target.checked)}
                                                    />
                                                    <ByzMuiCheckBox
                                                        text={t("surgery-pre-post-preparation.form.left")}
                                                        checked={formData.bolgeIsaretlemesiCheckbox.sol}
                                                        onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "sol", e.target.checked)}
                                                    />
                                                    <ByzMuiCheckBox
                                                        text={t("surgery-pre-post-preparation.form.level")}
                                                        checked={formData.bolgeIsaretlemesiCheckbox.seviye}
                                                        onChange={(e) => handleCheckboxChange("bolgeIsaretlemesiCheckbox", "seviye", e.target.checked)}
                                                    />
                                                </Box>
                                            </Box>


                                            {/* Açıklama */}
                                            <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1, mt: 2 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                            <ByzMuiTextField
                                                fullWidth
                                                size="medium"
                                                multiline
                                                rows={2}
                                                value={formData.bolgeIsaretlemesiAciklama}
                                                onChange={(e) => handleInputChange("bolgeIsaretlemesiAciklama", e.target.value)}
                                            />
                                        </Box>

                                        {/* 2) Allerji Var mı? */}
                                        <Box sx={{ mb: 2 }}>
                                            <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q2")}</ByzMuiTypography>

                                            <Grid item xs={12} md={8}>
                                                <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                    <ByzMuiRadioButton
                                                        typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                        layout="row"
                                                        value={formData.alerjisiVarMiRadio}
                                                        onChange={(e) => handleRadioChange("alerjisiVarMiRadio", e.target.value)}
                                                    />
                                                </Box>

                                            </Grid>
                                        </Box>

                                        {/* 3) Pansuman Temiz mi? */}
                                        <Box sx={{ mb: 2 }}>
                                            <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q3.1")}</ByzMuiTypography>
                                            <Grid item xs={12} md={8}>
                                                <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                    <ByzMuiRadioButton
                                                        typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                        layout="row"
                                                        value={formData.pansumanTemizMiPostRadio}
                                                        onChange={(e) => handleRadioChange("pansumanTemizMiPostRadio", e.target.value)}
                                                    />
                                                </Box>
                                            </Grid>
                                            <ByzMuiTypography sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                            <ByzMuiTextField
                                                fullWidth
                                                size="medium"
                                                multiline
                                                rows={2}
                                                value={formData.pansumanTemizMiPostAciklama}
                                                onChange={(e) => handleInputChange("pansumanTemizMiPostAciklama", e.target.value)}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            {/* İkinci Kolon (4-6) */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, height: "100%" }}>
                                    {/* 4) Kanama Var mı? */}
                                    <Box sx={{ mb: 2 }}>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q4.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.kanamaVarMiPostRadio}
                                                    onChange={(e) => handleRadioChange("kanamaVarMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.kanamaVarMiPostAciklama}
                                            onChange={(e) => handleInputChange("kanamaVarMiPostAciklama", e.target.value)}
                                        />
                                    </Box>

                                    {/* 5) Herhangi Bir Dren Mevcut mu? */}
                                    <Box sx={{ mb: 2 }}>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q5.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.herhangiBirDrenMevcutMuPostRadio}
                                                    onChange={(e) => handleRadioChange("herhangiBirDrenMevcutMuPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <Box sx={{ pl: "22px", mt: 1 }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                <ByzMuiCheckBox
                                                    text={t("surgery-pre-post-preparation.form.if-yes-location-amount")}
                                                    checked={formData.herhangiBirDrenMevcutMuPostCheckbox.evetIseYeriVeMiktari}
                                                    onChange={(e) => handleCheckboxChange("herhangiBirDrenMevcutMuPostCheckbox", "evetIseYeriVeMiktari", e.target.checked)}
                                                />
                                            </Box>
                                        </Box>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.herhangiBirDrenMevcutMuPostAciklama}
                                            onChange={(e) => handleInputChange("herhangiBirDrenMevcutMuPostAciklama", e.target.value)}
                                        />
                                    </Box>

                                    {/* 6) Folay Sonda Var mı? */}
                                    <Box>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q6.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.folaySondaVarMiPostRadio}
                                                    onChange={(e) => handleRadioChange("folaySondaVarMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.folaySondaVarMiPostAciklama}
                                            onChange={(e) => handleInputChange("folaySondaVarMiPostAciklama", e.target.value)}
                                        />
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Üçüncü Kolon (7-9) */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, height: "100%" }}>
                                    {/* 7) Nazogastrik Sonda Var mı? */}
                                    <Box sx={{ mb: 2 }}>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q7.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.yes")},${t("surgery-pre-post-preparation.form.no")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.nazogastrikSondaVarMiPostRadio}
                                                    onChange={(e) => handleRadioChange("nazogastrikSondaVarMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.nazogastrikSondaVarMiPostAciklama}
                                            onChange={(e) => handleInputChange("nazogastrikSondaVarMiPostAciklama", e.target.value)}
                                        />
                                    </Box>

                                    {/* 8) Ameliyathanede Uygulanan İlaçlar Var mı? */}
                                    <Box sx={{ mb: 2 }}>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q8.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.ameliyathanedeUygulananIlaclarVarMiPostRadio}
                                                    onChange={(e) => handleRadioChange("ameliyathanedeUygulananIlaclarVarMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.ameliyathanedeUygulananIlaclarVarMiPostAciklama}
                                            onChange={(e) => handleInputChange("ameliyathanedeUygulananIlaclarVarMiPostAciklama", e.target.value)}
                                        />
                                    </Box>

                                    {/* 9) Kan Transfüzyonu Yapılmış mı? */}
                                    <Box>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }} >{t("surgery-pre-post-preparation.q9.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.kanTransfuzyonuYapilmisMiPostRadio}
                                                    onChange={(e) => handleRadioChange("kanTransfuzyonuYapilmisMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <Box sx={{ pl: "22px", mt: 1 }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                <ByzMuiCheckBox
                                                    text={t("surgery-pre-post-preparation.form.if-yes-how-many-units")}
                                                    checked={formData.kanTransfuzyonuYapilmisMiPostCheckbox.evetIseKacUnite}
                                                    onChange={(e) => handleCheckboxChange("kanTransfuzyonuYapilmisMiPostCheckbox", "evetIseKacUnite", e.target.checked)}
                                                />
                                            </Box>
                                        </Box>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.kanTransfuzyonuYapilmisMiPostAciklama}
                                            onChange={(e) => handleInputChange("kanTransfuzyonuYapilmisMiPostAciklama", e.target.value)}
                                        />
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Dördüncü Kolon (10) */}
                            <Grid item xs={12} md={3}>
                                <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2, height: "100%" }}>
                                    {/* 10) Hastadan Patoloji Örneği Gönderilmiş mi? */}
                                    <Box>
                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.q10.1")}</ByzMuiTypography>
                                        <Grid item xs={12} md={8}>
                                            <Box sx={{ '& > div': { flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' } }}>
                                                <ByzMuiRadioButton
                                                    typographyText={`${t("surgery-pre-post-preparation.form.ok")},${t("surgery-pre-post-preparation.form.nope")},${t("surgery-pre-post-preparation.form.unknown")}`}
                                                    layout="row"
                                                    value={formData.hastadanPatolojiOrnegiGonderilmisMiPostRadio}
                                                    onChange={(e) => handleRadioChange("hastadanPatolojiOrnegiGonderilmisMiPostRadio", e.target.value)}
                                                />
                                            </Box>
                                        </Grid>
                                        <Box sx={{ pl: "22px", mt: 1 }}>
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                <ByzMuiCheckBox
                                                    text={t("surgery-pre-post-preparation.form.if-yes-how-many-units")}
                                                    checked={formData.hastadanPatolojiOrnegiGonderilmisMiPostCheckbox.evetIseKacUnite}
                                                    onChange={(e) => handleCheckboxChange("hastadanPatolojiOrnegiGonderilmisMiPostCheckbox", "evetIseKacUnite", e.target.checked)}
                                                />
                                            </Box>
                                        </Box>

                                        <ByzMuiTypography textAlign="left" marginLeft="0px" sx={{ mb: 1 }}>{t("surgery-pre-post-preparation.desc")}</ByzMuiTypography>
                                        <ByzMuiTextField
                                            fullWidth
                                            size="medium"
                                            multiline
                                            rows={2}
                                            value={formData.hastadanPatolojiOrnegiGonderilmisMiPostAciklama}
                                            onChange={(e) => handleInputChange("hastadanPatolojiOrnegiGonderilmisMiPostAciklama", e.target.value)}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </Box >
    );
};

export default PostSurgeryTab; 